import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CreateNewAssessment from "./CreateNewAssessment";
import permissions, { isAuthorized } from "client/utils/Permissions";
import { useSelector } from "react-redux";
import userProfileSelectors from "../../../../../redux/UserProfile/selectors"

const CreateNewAssessmentContainer = () =>{

    const navigate = useNavigate();
    const [quantity, setQuantity] = useState(1)
    const [addQuestionBtnClicked, setAddQuestionBtnClicked] = useState(false)
    const [showAssessmentQuestion, setShowAssessmentQuestion] = useState(false)
    const [assessmentTitle, setAssessmenttitle] = useState('')
    const [passingPercentage, setPassingPercentage] = useState<number>()
    const [error, setError] = useState<any>({})

    const { userDetails } : any = useSelector((state: any) => ({ 
      userDetails: userProfileSelectors.getUserDetails(state),
    }))

    useEffect(() => {
      if(userDetails?.permissions?.length && !(isAuthorized(permissions.CreateAssessment) || isAuthorized(permissions.ViewAssessment))){
        navigate('/assetinventory')
      }
    }, [userDetails?.permissions])
    
    const breadcrumlist = [
        {
          text: "Home",
          key: "f1",
          href: "/ordermanagement",
          onClick: (e: any) => {
            e.preventDefault();
            handleClickBack()
          },
        },
        { text: "Create New Assessment", key: "f4" },
    ];

    const assessmentTopicOption = [
        { value:'Select Assessment Topic',label:'Select Assessment Topic'},
        { value:'All States',label:'All States'},
        { value:'CA Only',label:'CA Only'},
        { value:'Non CA Only',label:'7Non CA Only2'}
    ];
    const passingScoreTypeOption = [
        { value:'Select Passing Score Type',label:'Select Passing Score Type'},
        { value:'All States',label:'All States'},
        { value:'CA Only',label:'CA Only'},
        { value:'Non CA Only',label:'7Non CA Only2'}
    ];

    const validateAssessmentTitle = (value: any) => {
      let isValid = true
      if(!value){
        isValid = false
        setError((prev: any) => ({...prev, assessementError: 'Please provide assessment title'}))
      } else {
        setError((prev: any) => ({...prev, assessementError: ''}))
      }
      return isValid
    }

    const validatePassingPercentage = (value: any) => {
      let isValid = true
      if(!value){
        isValid = false
        setError((prev: any) => ({...prev, passingPercentageError: 'Please provide passing percentage'}))
      } else if (isNaN(value.toString()) || parseInt(value) <= 0) {
        isValid = false
        setError((prev: any) => ({...prev, passingPercentageError: 'Please provide passing percentage value in number'}))
      } else if(parseInt(value) > 100){
        isValid = false
        setError((prev: any) => ({...prev, passingPercentageError: 'Please provide passing percentage value less than or equals to 100'}))
      } else {
        setError((prev: any) => ({...prev, passingPercentageError: ''}))
      }
      return isValid
    }


    const handleClickBack = () =>{
        navigate('/assetinventory/questions')
        setAddQuestionBtnClicked(false)
        setQuantity(1)
        setShowAssessmentQuestion(false)
        setAssessmenttitle('')
        setPassingPercentage(undefined)
        setError({})
    }

    const onChangeQuantity = (e: any) => {
      if (e.target.value == '' || parseInt(e.target.value) == 0) {
        setQuantity(1);
      }
      else {
        setQuantity(parseInt(e.target.value));
      }
    }

    const incrementQuantity = () => {
      setQuantity(quantity + 1)
    }

    const decrementQuantity = () => {
      if (quantity !== 0) {
        setQuantity(quantity - 1)
      }
    }

    const onChangeAssessmentTitle = (value: any) => {
      validateAssessmentTitle(value)
      setAssessmenttitle(value)
    }

    const onChangePassingPercentage = (value: any) => {
      if (isNaN(value.toString()) || parseInt(value) <= 0) {
        validatePassingPercentage(value)
      } else{
        validatePassingPercentage(value)
        setPassingPercentage(Number(value))
      }
    }

    const validate = () => {
      let isValid = true
      const isPercentageValid = validatePassingPercentage(passingPercentage)
      const isAssessmentValid = validateAssessmentTitle(assessmentTitle)
      if(!isPercentageValid || !isAssessmentValid){
        isValid = false
      }
      return isValid
    }

    const onClickAddQuestionBtn = () => {
      let isValid = validate()
      if(isValid){
        setAddQuestionBtnClicked(true)
        setShowAssessmentQuestion(true)
      }
    }

    return <CreateNewAssessment 
        breadcrumlist={breadcrumlist}
        handleClickBack={handleClickBack}
        assessmentTitle={assessmentTitle}
        onChangeAssessmentTitle={onChangeAssessmentTitle}
        passingPercentage={passingPercentage}
        onChangePassingPercentage={onChangePassingPercentage}
        assessmentTopicOption={assessmentTopicOption}
        passingScoreTypeOption={passingScoreTypeOption}
        onChangeQuantity={onChangeQuantity}
        incrementQuantity={incrementQuantity}
        decrementQuantity={decrementQuantity}
        quantity={quantity}
        onClickAddQuestionBtn={onClickAddQuestionBtn}
        addQuestionBtnClicked={addQuestionBtnClicked}
        showAssessmentQuestion={showAssessmentQuestion}
        error={error}
    />
}

export default CreateNewAssessmentContainer;